import React, { Component } from 'react';
import CountUp from 'react-countup';
import '../css/yaneodoo.css';
import Bg01 from '../images/Event/yaneodoo/bg_01.png';
import Bg02 from '../images/Event/yaneodoo/bg_02.png';
import Bg03 from '../images/Event/yaneodoo/bg_03.png';
import Bg04 from '../images/Event/yaneodoo/bg_04.png';
import Bg05 from '../images/Event/yaneodoo/bg_05.png';
import Bg06 from '../images/Event/yaneodoo/bg_06.png';
import Model from '../images/Event/yaneodoo/model.png';
import * as Common from '../components/Common';
import { Actions } from '../components/Actions';

class Yaneodoo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenPopup: false,
      totalCnt: 0,
      name: "",
      tel: "",
      code: "",
      myTotalCnt: 0
    };
  }

  componentDidMount() {
    this._getTotalCnt();

    Actions.alertOpen({msg: "응모기간이 종료되었습니다."}, [{type: 'ok', label: '확인', callback: Actions.goBack}]);
    return;
  }

  /**
   * 전체 응모 갯수 조회
   */
  _getTotalCnt() {
    Common.callApi('/promotion/totalCntYaneodoo', 'get', null)
    .then(result => {
      if(result.resultCode === "success") {
        var resultData = result.resultData;
        if(resultData) {
          this.setState({ totalCnt: resultData.totalCnt });
        }
      }
    });
  }

  /**
   * 야너두 이벤트 응모
   */
  _doAuth() {
    var name = this.state.name;
    var tel = this.state.tel;
    var code = this.state.code;

    if(!name) {
      Actions.alertOpen({msg: "이름을 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(!tel) {
      Actions.alertOpen({msg: "연락처를 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(Common.checkExp(tel)) {
      Actions.alertOpen({msg: "숫자만 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(!code) {
      Actions.alertOpen({msg: "응모코드번호를 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(Common.checkExp(code)) {
      Actions.alertOpen({msg: "숫자만 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    Common.callApi("/promotion/yaneodoo/" + this.state.name + "/" + this.state.tel + "/" + this.state.code, 'get', null)
    .then(result => {
      if(result.resultCode === "success") {
        this.setState({ 
          isOpenPopup: true,
          myTotalCnt: result.resultData.totalCnt
        });
      }
    });
  }

  _renderPopup() {
    return (
      <div className="popupArea">
        <div className="popupContentsArea">
          <div className="popupTextArea">
            <div style={{margin: '45% 0 0 13%'}}>
              {this.state.name}&nbsp;님의<br/>
              <span className="bold yellow">행운권&nbsp;</span>
              <span className="bold yellow">{this.state.myTotalCnt}</span>&nbsp;<span className="yellow">개</span><br/>
              등록완료!
            </div>
            <a href="/yaneodoo" className="close"></a>
          </div>
          <div className="modelArea">
            <div className="modelWrap">
              <img src={Model} className="model" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont yaneodoo" >
              <div id="contents" style={{background: '#461187'}}>
                <div className="info-cont" style={{textAlign: 'center'}}>
                  <div style={{backgroundColor: '#461187'}}><img src={Bg01} style={{width: '100%'}} /></div>
                  <div className="entryCntWrap">
                    <div className="entryCntArea">
                      <div className="entryCntContents">
                        토즈 회원 전체 <span className="entryDesc">총</span> <CountUp className="entryCnt" end={this.state.totalCnt} separator=","></CountUp><span className="entryDesc">장의<br/>행운권</span>이 응모완료 되었습니다!
                      </div>
                    </div>
                  </div>
                  <div style={{backgroundColor: '#ede7f5', marginTop: '-1px'}}><img src={Bg03} style={{width: '100%'}} /></div>
                  <div style={{backgroundColor: '#ffd02d', marginTop: '-1px'}}>
                    <a href="https://www.toz.co.kr/event/detail/ongoing/StudyTOZ/202"><img src={Bg04} style={{width: '100%'}} /></a>
                  </div>
                  <div style={{backgroundColor: '#461187', marginTop: '-1px'}}><img src={Bg05} style={{width: '100%'}} /></div>
                  <div style={{width: '100%', display: 'table'}}>
                    <div style={{display: 'table-cell', textAlign: 'center'}}>
                      <div className="inputArea">
                        <input type="text" placeholder="이&nbsp;&nbsp;름" onChange={(e) => this.setState({name: e.target.value})} />
                        <input type="number" placeholder="연&nbsp;&nbsp;락&nbsp;&nbsp;처(숫자만 입력)" style={{marginTop: '5px'}} maxLength="11" onChange={(e) => this.setState({tel: e.target.value})} />
                        <input type="number" placeholder="응&nbsp;&nbsp;모&nbsp;&nbsp;코&nbsp;&nbsp;드&nbsp;&nbsp;번&nbsp;&nbsp;호" maxLength="16" style={{marginTop: '5px'}} onChange={(e) => this.setState({code: e.target.value})} />
                        <div className="desc">※ 토즈 등록 회원 본인의 이름, 연락처, 응모코드와 정확히 일치해야 인증됩니다.</div>
                      </div>
                    </div>
                  </div>
                  <div style={{width: '100%', display: 'table'}}>
                    <div style={{display: 'table-cell', textAlign: 'center'}}>
                      <button onClick={() => this._doAuth()}>인&nbsp;&nbsp;증</button>
                    </div>
                  </div>
                  <div style={{backgroundColor: '#461187'}}><img src={Bg06} style={{width: '100%'}} /></div>
                </div>
              </div>

              {this.state.isOpenPopup ? this._renderPopup() : ""}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Yaneodoo;